/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFrozenStatus_Query = { readonly __typename: 'Query', readonly frozenAuthorizedSigner: boolean | null };


export type GetFrozenStatusVariables = _Types.Exact<{
  companyId: _Types.Scalars['String']['input'];
}>;


export type GetFrozenStatus = GetFrozenStatus_Query;


export const GetFrozenStatusDocument = gql`
    query GetFrozenStatus($companyId: String!) {
  frozenAuthorizedSigner(companyId: $companyId)
}
    `;

/**
 * __useGetFrozenStatus__
 *
 * To run a query within a React component, call `useGetFrozenStatus` and pass it any options that fit your needs.
 * When your component renders, `useGetFrozenStatus` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFrozenStatus({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetFrozenStatus(baseOptions: Apollo.QueryHookOptions<GetFrozenStatus, GetFrozenStatusVariables> & ({ variables: GetFrozenStatusVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFrozenStatus, GetFrozenStatusVariables>(GetFrozenStatusDocument, options);
      }
export function useGetFrozenStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFrozenStatus, GetFrozenStatusVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFrozenStatus, GetFrozenStatusVariables>(GetFrozenStatusDocument, options);
        }
export function useGetFrozenStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFrozenStatus, GetFrozenStatusVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFrozenStatus, GetFrozenStatusVariables>(GetFrozenStatusDocument, options);
        }
export type GetFrozenStatusHookResult = ReturnType<typeof useGetFrozenStatus>;
export type GetFrozenStatusLazyQueryHookResult = ReturnType<typeof useGetFrozenStatusLazyQuery>;
export type GetFrozenStatusSuspenseQueryHookResult = ReturnType<typeof useGetFrozenStatusSuspenseQuery>;
export type GetFrozenStatusQueryResult = Apollo.QueryResult<GetFrozenStatus, GetFrozenStatusVariables>;